import EngineWidgetModal from './engine-widget-modal';


export default class EngineWidgetOffers extends EngineWidgetModal {
    static _formatDate(input) {
        if (['', undefined].includes(input)) {
            return undefined;
        }
        return input.split('/').reverse().join('-');
    }

    _prepareInitialData() {
        const minDate = this.constructor._formatDate(this._trigger.dataset.desde);
        let maxDate = this.constructor._formatDate(this._trigger.dataset.hasta);
        if (this._trigger.dataset.lastminute === true) {
            maxDate = minDate;
        }
        return {
            ...super._prepareInitialData(),
            availableHotels: this._trigger.dataset.hoteles,
            datesOfferFrom: this._trigger.dataset.estancia,
            maxDate: maxDate,
            minDate: minDate,
            dataMinNoches: this._trigger.dataset.minimoNoches,
            offerCode: this._trigger.dataset.codigo,
            codpromo: this._trigger.dataset.codpromo
        };
    }
}
